import React from "react";
import RichTextEditor from "../RichTextEditor";

interface ProjectAdditionalContentProps {
  formData: {
    objective: string;
    urgencyAndNovelty: string;
    mainContents: string;
    applicationCapability: string;
    expectedBenefits: string;
    expectedResults: string;
    topicStatus: string;
  };
  handleInputChange: (field: string, value: string) => void;
}

const ProjectAdditionalContent: React.FC<ProjectAdditionalContentProps> = ({
  formData,
  handleInputChange,
}) => {
  return (
    <div className="space-y-6">
      {/* Mục tiêu - Full Width */}
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Mục tiêu
        </label>
        <textarea
          value={formData.objective}
          onChange={(e) => handleInputChange("objective", e.target.value)}
          className="w-full h-24 px-3 py-2 text-sm border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent resize-none"
          placeholder="Nhập mục tiêu của đề tài..."
        />
      </div>

      {/* Top Section - Two large text areas side by side */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        {/* Tính cấp thiết và tính mới của nhiệm vụ */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Tính cấp thiết và tính mới của nhiệm vụ (về mặt khoa học và về mặt
            thực tiễn)
          </label>
          <textarea
            value={formData.urgencyAndNovelty || ""}
            onChange={(e) =>
              handleInputChange("urgencyAndNovelty", e.target.value)
            }
            className="w-full h-32 px-3 py-2 text-sm border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent resize-none"
            placeholder="Nhập tính cấp thiết và tính mới..."
          />
        </div>

        {/* Các nội dung chính */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Các nội dung chính:
          </label>
          <textarea
            value={formData.mainContents || ""}
            onChange={(e) => handleInputChange("mainContents", e.target.value)}
            className="w-full h-32 px-3 py-2 text-sm border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent resize-none"
            placeholder="Nhập các nội dung chính..."
          />
        </div>
      </div>

      {/* Middle Section - Two more large text areas side by side */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        {/* Khả năng và địa chỉ ứng dụng */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Khả năng và địa chỉ ứng dụng:
          </label>
          <textarea
            value={formData.applicationCapability || ""}
            onChange={(e) =>
              handleInputChange("applicationCapability", e.target.value)
            }
            className="w-full h-32 px-3 py-2 text-sm border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent resize-none"
            placeholder="Nhập khả năng và địa chỉ ứng dụng..."
          />
        </div>

        {/* Dự kiến hiệu quả mang lại */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Dự kiến hiệu quả mang lại:
          </label>
          <textarea
            value={formData.expectedBenefits || ""}
            onChange={(e) =>
              handleInputChange("expectedBenefits", e.target.value)
            }
            className="w-full h-32 px-3 py-2 text-sm border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent resize-none"
            placeholder="Nhập dự kiến hiệu quả..."
          />
        </div>
      </div>

      {/* Kết quả dự kiến - Full Width */}
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Kết quả dự kiến:
        </label>
        <RichTextEditor
          value={formData.expectedResults || ""}
          onChange={(value) => handleInputChange("expectedResults", value)}
          placeholder="Nhập nội dung kết quả dự kiến..."
          height="medium"
        />
      </div>

      {/* Trạng thái đề tài */}
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Trạng thái đề tài <span className="text-red-500">(*)</span>
        </label>
        <select
          value={formData.topicStatus || ""}
          onChange={(e) => handleInputChange("topicStatus", e.target.value)}
          className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
        >
          <option value="">- Chọn trạng thái -</option>
          <option value="draft">Bản nháp</option>
          <option value="submitted">Đã nộp</option>
          <option value="reviewing">Đang xem xét</option>
          <option value="approved">Đã phê duyệt</option>
          <option value="rejected">Bị từ chối</option>
        </select>
      </div>
    </div>
  );
};

export default ProjectAdditionalContent;
